import { defineComponent as _defineComponent } from 'vue';
import { reactiveOmit } from "@vueuse/core";
import { cn } from './../utils';
import TableCell from "./TableCell.vue";
import TableRow from "./TableRow.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'TableEmpty',
    props: {
        class: { type: [Boolean, null, String, Object, Array], required: false, skipCheck: true },
        colspan: { type: Number, required: false, default: 1 }
    },
    setup(__props, { expose: __expose }) {
        __expose();
        const props = __props;
        const delegatedProps = reactiveOmit(props, "class");
        const __returned__ = { props, delegatedProps, get cn() { return cn; }, TableCell, TableRow };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
